const FleetAccountType = {
    FleetAccount: "fleet-account",
    KeyAccount: "key-account",
};

export default FleetAccountType;
  